import { CheckpointType } from '../models/CheckpointType';
import { ISecurityCheckpoint } from '../models/ISecurityCheckpoint';

export const filterCheckpoints = (checkpoints: ISecurityCheckpoint[]) =>
	checkpoints.filter(
		(checkpoint) => !checkpoint.attributes?.includes(CheckpointType.FIS),
	);
